import React from "react";
import Skeleton from "react-loading-skeleton";
const ReportsShimmer = () => {
    return (React.createElement("div", { className: "d-flex flex-column gap-4" },
        React.createElement("div", { className: "shimmer_skeleton" },
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 70, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 70, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 70, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 70, width: "100%", className: "align-top" }))),
        React.createElement("div", { className: "shimmer_skeleton" },
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 45, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 45, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 45, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 45, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary" },
                React.createElement(Skeleton, { height: 45, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary", style: { width: "6%" } },
                React.createElement(Skeleton, { height: 45, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary", style: { width: "6%" } },
                React.createElement(Skeleton, { height: 45, width: "100%", className: "align-top" }))),
        React.createElement("div", { className: "shimmer_skeleton flex-column gap-1" },
            React.createElement("div", { className: "shimmer_summary w-100" },
                React.createElement(Skeleton, { height: 50, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary w-100" },
                React.createElement(Skeleton, { height: 50, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary w-100" },
                React.createElement(Skeleton, { height: 50, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary w-100" },
                React.createElement(Skeleton, { height: 50, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary w-100" },
                React.createElement(Skeleton, { height: 50, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "shimmer_summary w-100" },
                React.createElement(Skeleton, { height: 50, width: "100%", className: "align-top" })))));
};
export default ReportsShimmer;
